export default "__VITE_ASSET__JL9jzae2__"